import { useMutation } from '@grandvisionhq/graphql';
import { useNewsletterSubmit } from './use-newsletter-submit.js';
import { SUBSCRIBE_NEWSLETTER_OPT_IN } from '../operations/mutations/subscribe-newsletter-opt-in.js';

// currently used only by Synoptik Opcos
const useSubscribeNewsletterViaOptIn = ()=>{
    const [subscribeNewsletter] = useMutation(SUBSCRIBE_NEWSLETTER_OPT_IN, {
        onError: (error)=>{
            console.error(`Error occurred while executing the newsletter mutation: ${error}`);
        }
    });
    const { onSubmit  } = useNewsletterSubmit(subscribeNewsletter);
    return {
        onSubmit
    };
};

export { useSubscribeNewsletterViaOptIn };
//# sourceMappingURL=use-subscribe-newsletter-via-opt-in.js.map
